import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const RouteStatus = ({ code, children }) => (
  <Route
    render={
      ({ staticContext }) => {
        if (staticContext) {
          staticContext.status = code;
        }

        return children;
      }
    }
  />
);

RouteStatus.propTypes = {
    children: PropTypes.object,
    code: PropTypes.number.isRequired,
};

export default RouteStatus;



// WEBPACK FOOTER //
// ./src/components/Global/RouteStatus.jsx